import { useEffect, useState } from "react";
import "./index.scss";
import { Form, Input, Toast, Divider } from 'antd-mobile'
import CustomScroll from '@src/component/customScroll'
import BottomIcon from '@src/component/bottomIcon'
import store from '@src/util/store'
import { getConfigByKey, isEmpty, regular } from '@src/util'
import { goto } from "@src/route";
import ProgressBar from "@src/component/ProgressBar";
import { getBaseAreaData } from "@src/service/commonService";
import JcPicker from "@src/component/jcPicker";
import { getOriginApplyLoans, submitInsured } from "@src/service/ownService";
import PickFengzhuang from "@src/component/PickFengzhuang";
import SimulationInput from '@src/component/SimulationInput';
type regioninitType = {
  id: number,
  value: string,
  cfExperiment: number,
  children: any[],
  label?: string
}

export default function Index() {
  const [form] = Form.useForm(); //表单数据
  const [provList, setProvList] = useState<any[]>([]); // 地址列表
  const [pickVis, setPickVis] = useState<boolean>(false);//现住址vis
  const [unitPickVis, setUnitPickVis] = useState<boolean>(false);//现住址vis
  const [relation, setRelation] = useState([]); // 联系人
  const [stockpile, setStockpile] = useState<any>();// 储存的form
  const [isFixIdentifyAddress, setIsFixIdentifyAddress] =  useState<boolean>(true);//是否显示身份证地址
  const loanid = store.get('loanid')
  // 设置title
  useEffect(() => {
    document.title = "申请人相关信息";
  }, [])


  useEffect(() => {
    // 获取地址列表
    getPickerData();
    // 获取关系列表
    if (getConfigByKey("gx")?.length) {
      setRelation(getConfigByKey("gx"))
    } else {
      setTimeout(() => {
        if (getConfigByKey("gx")?.length) {
          setRelation(getConfigByKey("gx"))
        }
      }, 3000);
    }
  }, [])

  // 回填数据
  useEffect(() => {
    // 获取提交数据
    form.setFieldsValue({
      liaisons: [{}, {}]
    })
    getOriginApplyLoans(loanid).then((res: any) => {
      setIsFixIdentifyAddress(res.isFixIdentifyAddress)
      form.setFieldsValue({
        name: res.name,
        identifyNumber: res.identifyNumber,
        identifyAddress: res.identifyAddress,
      })
      if (res&&res.email) {
        setData(res)
      } else {
        if ((store.get('history'))?.loanInsured) {
          setData((store.get('history'))?.loanInsured, true)
        }
      }
    }).catch(err => {
      err?.errmsg && Toast.show(err?.errmsg)
      if ((store.get('history'))?.loanInsured) {
        setData((store.get('history'))?.loanInsured, true)
      }
    })
  }, [])

  // 获取回填数据
  const setData = (data: any, type?:boolean) => {
    if (type) {
      delete data.name
      delete data.identifyNumber
      delete data.identifyAddress
    }
    let addressAll = ''
    if (data.addressProvince && data.addressCity && data.addressCounty) {
      addressAll = `${data.addressProvince as string}/${data.addressCity as string}/${data.addressCounty as string}`
    }
    let unitAddressAll = ''
    if (data.unitAddressProvince && data.unitAddressCity && data.unitAddressCounty) {
      unitAddressAll = `${data.unitAddressProvince as string}/${data.unitAddressCity as string}/${data.unitAddressCounty as string}`
    }
    if (!data.liaisons) {
      data.liaisons = [{}, {}]
    }
    data.liaisons = data.liaisons.sort(function(a:any,b:any){
      if (!b.idx) {
        return -1
      }
      return a.idx - b.idx
    })
    if (data.liaisons.length < 2) {
      for (let i = data.liaisons.length; i < 2; i++) {
        data.liaisons.push({})
      }
    }
    for (const key in data) {
      if (isEmpty(data[key])) {
        delete data[key]
      }
    }
    form.setFieldsValue({
      ...data,
      addressAll,
      unitAddressAll
    })
    setStockpile(form.getFieldsValue(true))
  }

  // 获取省市区列表
  const getPickerData = async () => {
    try {
      const regioninit: any = await getBaseAreaData();
      const arrData = setPickerData(regioninit);
      setProvList(arrData);
    } catch (error: any) {
      Toast.show(error?.errmsg);
    }
  }

  // 格式化省市区列表
  const setPickerData = (list: any[]) => {
    const arr: any[] = list.map((item: regioninitType) => {
      if (item?.children?.length > 0) {
        const ca = setPickerData(item.children);
        item.children = ca;
      }
      item.label = item.value;
      item.value = `${item.id || ''}:${item.value || ''}`;
      return item;
    })
    return arr;
  }

  /**
   * 回填选择省市区
   * @param obj 
   * @param type 1为自己地址，2为单位地址
   */
  const setForm = (obj: any, type: number) => {
    const provinceA: [number, string] = (obj[0] || '').split(':');
    const city: [number, string] = (obj[1] || '').split(':');
    const area: [number, string] = (obj[2] || '').split(':');
    if (type == 1) {
      form.setFieldsValue({
        addressProvince: provinceA[1],
        addressProvinceCode: provinceA[0],
        addressCity: city[1],
        addressCityCode: city[0],
        addressCounty: area[1],
        addressCountyCode: area[0],
        addressAll: `${provinceA[1]}/${city[1]}/${area[1]}`
      })
    } else {
      form.setFieldsValue({
        unitAddressProvince: provinceA[1],
        unitAddressProvinceCode: provinceA[0],
        unitAddressCity: city[1],
        unitAddressCityCode: city[0],
        unitAddressCounty: area[1],
        unitAddressCountyCode: area[0],
        unitAddressAll: `${provinceA[1]}/${city[1]}/${area[1]}`
      })
    }

  }

  // 提交
  const subClick = () => {
    form.validateFields().then(res => {
      res.loanid = loanid
      Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
        maskClickable: false
      })
      submitInsured(res).then(() => {
        Toast.clear()
        goto('/apply/w3')
      }).catch(err => {
        Toast.show(err?.errmsg || '数据保存失败！')
      })
    })
  }

  return (<div className="page bottomFit applyInformation">
    <header>
      <ProgressBar point={70} />
    </header>
    <CustomScroll>
      <div className="top-box">
        <div className="float-box"></div>
        <div className="inputForm">
          <Form form={form} layout='horizontal' onValuesChange={() => {
            setStockpile(form.getFieldsValue(true))
          }}>
            <div className="form-Box">
              <div className="title">
                <h1 className="dotted-line">申请人信息</h1>
                <p>信息真实，通过率<span>提升50%</span></p>
              </div>
              {isFixIdentifyAddress&&<>
              <Form.Item name='name' label='姓&nbsp;&nbsp;&nbsp;&nbsp;名：'>
                  <Input placeholder='请输入姓名' maxLength={15} minLength={2} readOnly />
              </Form.Item>
              <Form.Item name="identifyNumber" label='身份证号：'>
                  <Input placeholder='请输入身份证号' maxLength={18} readOnly />
              </Form.Item>
              <Form.Item name="identifyAddress" label='身份证地址：' rules={[{ required: true, message: '请输入身份证地址' }]}>
                  <Input placeholder='请输入身份证地址' maxLength={40} />
              </Form.Item>
              </>}
              <div className="conceal-inputting">
                <Form.Item name="addressProvince"><Input /></Form.Item>
                <Form.Item name="addressProvinceCode"><Input /></Form.Item>
                <Form.Item name="addressCity"><Input /></Form.Item>
                <Form.Item name="addressCityCode"><Input /></Form.Item>
                <Form.Item name="addressCounty"><Input /></Form.Item>
                <Form.Item name="addressCountyCode"><Input /></Form.Item>
                <Form.Item name="unitAddressProvince"><Input /></Form.Item>
                <Form.Item name="unitAddressProvinceCode"><Input /></Form.Item>
                <Form.Item name="unitAddressCity"><Input /></Form.Item>
                <Form.Item name="unitAddressCityCode"><Input /></Form.Item>
                <Form.Item name="unitAddressCountyCode"><Input /></Form.Item>
                <Form.Item name="unitAddressCounty"><Input /></Form.Item>
              </div>
              <Form.Item name="email" label='申请人邮箱：' rules={[{ required: true, message: '请输入申请人邮箱' }, { type: "email", message: '请输入正确的邮箱格式' }]}>
                <Input maxLength={30} placeholder='请输入申请人邮箱' />
              </Form.Item>
              <div className="more-xia">
                <Form.Item name="addressAll" label='现住址：' onClick={() => { setPickVis(true) }} arrow={false} rules={[{ required: true, message: '请选择现住址' }]}>
                  <SimulationInput placeholder='省、市、区' />
                </Form.Item>
              </div>
              <Form.Item name="addressDetail" label='现住详细地址：' rules={[{ required: true, message: '请填写现住详细地址' }]}>
                <Input maxLength={40} placeholder='请填写现住详细地址' />
              </Form.Item>
              <Form.Item name="uint" label='单位名称：' rules={[{ required: true, message: '请输入单位名称' }]}>
                <Input maxLength={30} placeholder='请填写工作单位完整名称' />
              </Form.Item>
              <div className="more-xia">
                <Form.Item name="unitAddressAll" label='单位地址：' rules={[{ required: true, message: '请选择单位地址' }]} arrow={false} onClick={() => setUnitPickVis(true)}>
                  <SimulationInput placeholder='省、市、区' />
                </Form.Item>
              </div>
              <Form.Item name="unitAddress" label='单位详细地址：' rules={[{ required: true, message: '请填写现单位详细地址' }]}>
                <Input maxLength={40} placeholder='请填写现单位详细地址' />
              </Form.Item>
              <Form.Item name="unitPhoneNumber" label='单位电话：' rules={[{ required: true, message: '请输入单位电话' }]}>
                <Input onChange={() => {
                  const unitPhoneNumber = form.getFieldsValue(true).unitPhoneNumber
                  form.setFieldsValue({
                    unitPhoneNumber: unitPhoneNumber.replace(/\D/g, '')
                  })
                }} placeholder='请填写单位电话' />
              </Form.Item>
            </div>
            <div className="form-Box">
              <div className="title">
                <h1 className="dotted-line">紧急联系人信息</h1>
              </div>
              <Form.Array name='liaisons'>
                {
                  fields => fields.map(({ index }) => {
                    // 设置选项
                    const getRelation = (index: number) => {
                      const liaisons = stockpile?.liaisons
                      if (!liaisons) {
                        return relation
                      }
                      let lock = false
                      for (const item of liaisons) {
                        if (item.relation == 2) {
                          lock = true
                        }
                      }
                      if (lock) {
                        if (liaisons[index].relation == 2) {
                          return relation
                        } else {
                          return relation.filter((res: any) => res.value != 2)
                        }
                      } else {
                        return relation
                      }
                    }
                    return <>
                      {index != 0 && <Divider style={{borderColor: '#E9E9E9'}} />}
                      <div className="more-xia">
                        <Form.Item name={[index, 'relation']} label='与本人关系：' rules={index == 2 ? [] : [{ required: true, message: '请选择联系人与本人关系' }]}>
                          <PickFengzhuang placeholder='请选择与本人关系' columns={getRelation(index)} />
                        </Form.Item>
                      </div>
                      <div className="conceal-inputting">
                        <Form.Item name="idx">
                          <Input value={`${index + 1}`} />
                        </Form.Item>
                        <Form.Item name="remark">
                          <Input />
                        </Form.Item>
                      </div>
                      <Form.Item name={[index, 'name']} label='联系人姓名：' rules={index == 2 ? [] : [{ required: true, message: '请输入紧急联系人姓名' }, { min: 2, max: 20, message: "姓名长度为2-20" }]}>
                        <Input maxLength={20} placeholder='请输入紧急联系人姓名' />
                      </Form.Item>
                      <Form.Item name={[index, 'mobile']} label='手机号码：' rules={index == 2 ? [] : [{ required: true, message: '请输入紧急联系人手机号码' }, { pattern: regular('phone'), len: 11, message: "输入手机号格式错误", validateTrigger: 'onBlur' }]}>
                        <Input type="number" placeholder='请输入紧急联系人手机号码' onChange={(e) => {
                          const liaisons = form.getFieldsValue(true).liaisons
                          liaisons[index].mobile = e.replace(/\D/g, '').substring(0, 11)
                          form.setFieldsValue({
                            liaisons
                          })
                          setTimeout(() => {
                            form.validateFields(['liaisons.1.mobile'])
                          }, 200);
                        }} />
                      </Form.Item>
                      {stockpile?.liaisons[index]?.relation == 2 && <Form.Item name={[index, 'uint']} label='单位名称：' rules={index == 2 ? [] : [{ required: true, message: '请输入配偶的单位名称' }]}>
                        <Input maxLength={30} placeholder='请输入单位名称' />
                      </Form.Item>}
                    </>
                  })
                }
              </Form.Array>
            </div>
          </Form>
        </div>
      </div>
      <footer>
        <div className="button-them submit" onClick={subClick}>下一步</div>
      </footer>
      {/* <div style={{paddingBottom: 100}}></div> */}
      <BottomIcon />
    </CustomScroll>
    {/* 个人住址picker */}
    <JcPicker
      visible={pickVis}
      list={provList}
      setForm={(obj: any) => { setForm(obj, 1) }}
      setVisible={setPickVis} />
    {/* 公司地址picker */}
    <JcPicker
      visible={unitPickVis}
      list={provList}
      setForm={(obj: any) => { setForm(obj, 2) }}
      setVisible={setUnitPickVis} />
  </div>)
}
